import { useTranslation } from 'react-i18next'
import { FCC } from '~/core/@types/global'
import { cn } from '~/core/ui/utils'
import SectionContainer from '../LandingPage/components/section/SectionContainer'

const PLUS = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none">
    <line y1="6.5" x2="13" y2="6.5" stroke="#9CA3AF" />
    <line x1="6.5" y1="2.18557e-08" x2="6.5" y2="13" stroke="#9CA3AF" />
  </svg>
)

const DesignedForGrowthSection: FCC<{ className?: string }> = ({
  className
}) => {
  const { t, i18n } = useTranslation()

  const SECTIONS = [
    {
      contentHeading: t(
        'aboutUs:designed_for_growth:section_1_content_heading'
      ),
      contentTitle: t('aboutUs:designed_for_growth:section_1_content_title'),
      contentDescription: t(
        'aboutUs:designed_for_growth:section_1_content_description'
      ),
      contentBox: [
        t('aboutUs:designed_for_growth:section_1_content_box01'),
        t('aboutUs:designed_for_growth:section_1_content_box02'),
        t('aboutUs:designed_for_growth:section_1_content_box03')
      ]
    },
    {
      contentHeading: t(
        'aboutUs:designed_for_growth:section_2_content_heading'
      ),
      contentTitle: t('aboutUs:designed_for_growth:section_2_content_title'),
      contentDescription: t(
        'aboutUs:designed_for_growth:section_2_content_description'
      ),
      contentBox: [
        t('aboutUs:designed_for_growth:section_2_content_box01'),
        t('aboutUs:designed_for_growth:section_2_content_box02'),
        t('aboutUs:designed_for_growth:section_2_content_box03')
      ],
      contentLink: '#'
    }
  ]

  return (
    <SectionContainer
      title="aboutUs:designed_for_growth:title"
      description="aboutUs:designed_for_growth:description"
      tagLabel="aboutUs:designed_for_growth:tag"
      tagColor="bg-green-100 text-green-800"
      className={cn(className, 'pb-5 my-[44px] desktop:my-[140px]')}>
      <div className="relative">
        <div className="h-5 border-gray-100 border-r absolute -top-5 left-0 border-dashed" />
        <div className="w-5 border-gray-100 border-t absolute top-0 -left-5 border-dashed" />
        <div className="absolute -top-1.5 -left-1.5 z-10">{PLUS}</div>

        <div className="h-5 border-gray-100 border-r absolute -top-5 right-0 border-dashed" />
        <div className="w-5 border-gray-100 border-t absolute top-0 -right-5 border-dashed" />
        <div className="absolute -top-1.5 -right-1.5 z-10">{PLUS}</div>

        <div className="h-5 border-gray-100 border-r absolute -bottom-5 left-0 border-dashed" />
        <div className="w-5 border-gray-100 border-t absolute bottom-0 -left-5 border-dashed" />
        <div className="absolute -bottom-1.5 -left-1.5 z-10">{PLUS}</div>

        <div className="h-5 border-gray-100 border-r absolute -bottom-5 right-0 border-dashed" />
        <div className="w-5 border-gray-100 border-t absolute bottom-0 -right-5 border-dashed" />
        <div className="absolute -bottom-1.5 -right-1.5 z-10">{PLUS}</div>

        <div className="flex flex-col tablet:flex-wrap tablet:flex-row align-middle w-full justify-center mt-10 border-gray-100 border border-r-0">
          {SECTIONS.map((item, index) => (
            <div
              key={index}
              className="flex-1 min-w-[50%] border-gray-100 border-r">
              <div className="px-8 pb-8 pt-6 relative">
                {item.contentHeading ? (
                  <span className="font-medium text-base uppercase text-white bg-gray-600 px-2 leading-6 rounded-sm absolute left-8 -top-6 mt-3">
                    {item.contentHeading}
                  </span>
                ) : null}
                <p className="font-medium text-lg text-gray-900 mt-3">
                  {item.contentTitle}
                </p>
                <p className="font-normal text-base text-gray-700">
                  {item.contentDescription}
                </p>
                <div className="my-4">
                  <div className="h-px border-t border-dashed border-gray-100" />
                </div>
                <div className="space-y-3">
                  {item.contentBox.map((box, index) => (
                    <div key={index} className="flex space-x-2">
                      <div className="w-1.5 h-1.5 bg-gray-600 rounded-md mt-2" />
                      <span className="text-base font-medium text-gray-900">
                        {box}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </SectionContainer>
  )
}

export default DesignedForGrowthSection
